export const HOST_ROLES = new Set(['teacher', 'admin', 'sales', 'mentor-lead']);
export const isHostRole = (role) => HOST_ROLES.has(role);
